/* eslint-disable react-hooks/exhaustive-deps */
import { forEach, get, isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';
import {
  createBankTransRecordsClient
} from '../../apis/finances/bank';
import { dateToViewFormat } from '../../utils/date';
import { restoreComma, transformComma } from '../../utils/validator/comma';
import Button from '../Button';
import IconButton from '../Button/IconButton';
import DeleteIcon from "../../assets/images/icon/delete-icon-01.svg";
import Input from '../Input';
import Modal, { ModalHeader } from '../Modal';
import SearchClientModal from "./SearchClientModal";
import { toast } from '../../utils/toast';
import { viewLoading } from '../../utils/loading';

const ClientMappingModal = ({ open, setOpen, selected, setSelected, submit, mode = "modify" }) => {
  const [fields] = useState([
    { title: "거래일자" },
    { title: "입금액" },
    { title: "출금액" },
    { title: "잔액" },
    { title: "거래자명" },
    { title: "매핑된 거래처" },
    { title: "거래처선택" },
    { title: "거래금액 및 새 거래처" },
  ]);
  const [bankTransList, setBankTransList] = useState(selected);
  const [isSearchClient, setIsSearchClient] = useState(false);
  const [bankTransIdx, setBankTransIdx] = useState(null);

  useEffect(() => {
    const transList = [];
    forEach(selected, (bankTrans) => {
      transList.push({
        tradeTime: bankTrans.tradeTime,
        inAmt: bankTrans.inAmt,
        outAmt: bankTrans.outAmt,
        balanceAmt: bankTrans.balanceAmt,
        traderName: bankTrans.traderName,
        clients: bankTrans.clients,
        bankTransIdx: bankTrans.idx,
        addClients: [],
      });
    });
    setBankTransList(transList);
  }, [selected]);

  const cancel = () => {
    setOpen(false);
    setSelected([]);
  };

  const handleOnChage = (e, transIdx, idx) => {
    const { name, value } = e.target;
    let newArray = [...bankTransList];
    newArray[transIdx]["addClients"][idx][name] = isEmpty(value) ? "" : transformComma(value);
    setBankTransList(newArray);
  };

  const handleOnSupply = () => {
    const list = [];
    forEach(bankTransList, (trans) => {
      if (isEmpty(trans.addClients)) {
        toast.error('모든 내역에 거래처를 매핑해주세요');
      } else {
        forEach(trans.addClients, (client) => {
          list.push({
            bankTransIdx: trans.bankTransIdx,
            clientIdx: client.idx,
            moneyIn: !isEmpty(client.moneyIn) ? Number(restoreComma(client.moneyIn)) : 0,
            moneyOut: !isEmpty(client.moneyOut) ? Number(restoreComma(client.moneyOut)) : 0,
          });
        });
      }
    });

    viewLoading(true);
    createBankTransRecordsClient({ list })
      .then((res) => {
        submit();
        cancel();
        toast.info("거래처가 매핑 되었습니다.");
      })
      .catch(() => { })
      .finally(() => {
        viewLoading(false);
      });
  };

  const handleRemoveAddClient = (transIdx, client) => {
    let newArray = [...bankTransList];
    newArray[transIdx] = {
      ...newArray[transIdx],
      addClients: newArray[transIdx].addClients.filter((c) => c.idx !== client.idx)
    };
    setBankTransList(newArray);
  };

  return (
    <>
      {!isSearchClient && (
        <Modal isOpen={open} close={cancel}>
          <div className="client-mapping-modal">
            <ModalHeader
              className={'w-full'}
              style={{
                display: 'block'
              }}
            >
              거래처 매핑하기

              <Button
                style={{ float: 'right' }}
                label="일괄 거래처 선택"
                size="sm"
                onClick={() => {
                  setIsSearchClient(true);
                  // setBankTransIdx(transIdx)
                }}
              />
            </ModalHeader>
            <div className="mapping-field">
              <table className="w-full">
                <thead>
                  <tr>
                    {fields.map((field, idx) => (
                      <th key={idx}>{field.title}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {bankTransList.map((trans, transIdx) => (
                    <tr key={transIdx}>
                      <td>{dateToViewFormat(get(trans, 'tradeTime'))}</td>
                      <td className="color-red-100">{transformComma(get(trans, 'inAmt'))}</td>
                      <td className="color-purple-100">{transformComma(get(trans, 'outAmt'))}</td>
                      <td>{transformComma(get(trans, 'balanceAmt'))}</td>
                      <td>{get(trans, 'traderName')}</td>
                      <td>
                        {!isEmpty(trans.clients) &&
                          trans.clients.map((client, idx) => (
                            <React.Fragment key={idx}>
                              <p>{client.name}</p>
                            </React.Fragment>
                          ))}
                      </td>
                      <td>
                        <Button
                          label="거래처 선택"
                          size="sm"
                          onClick={() => {
                            setIsSearchClient(true);
                            setBankTransIdx(transIdx);
                          }}
                        />
                      </td>
                      <td className="add-client-list">
                        {!isEmpty(trans.addClients) &&
                          trans.addClients.map((client, idx) => (
                            <div key={idx} className="client-wrap">
                              <div className="trade-money-wrap">
                                <Input
                                  name={get(trans, 'inAmt') > 0 ? `moneyIn` : `moneyOut`}
                                  value={get(trans, 'inAmt') > 0 ? client.moneyIn : client.moneyOut}
                                  onChange={(e) => handleOnChage(e, transIdx, idx)}
                                />
                              </div>
                              <div className="client-name-wrap">
                                <span>{client.name}</span>
                                <IconButton className="ml-4 vertical-middle" icon={DeleteIcon} action={() => handleRemoveAddClient(transIdx, client)} />
                              </div>
                            </div>
                          ))}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="submit-button-wrap float-right margin-top-32">
              <Button
                className="button"
                size="lg"
                label="취소"
                color="text"
                action={cancel}
              />
              <Button
                className="button"
                size="lg"
                label="적용하기"
                action={handleOnSupply}
              />
            </div>
          </div>
        </Modal>
      )}
      <SearchClientModal
        open={isSearchClient}
        setOpen={setIsSearchClient}
        selected={bankTransList}
        bankTransIdx={bankTransIdx}
        setSelected={setBankTransList}
        fields={fields.slice(0, 5)}
      />
    </>
  );
};

export default ClientMappingModal;